import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { CheckBox } from "components/CheckBox/CheckBox";
import React, { useMemo } from 'react';
import Select, { components } from "react-select";
import { PaymentInstallmentAmount, PaymentInstallmentCheckbox, PaymentInstallmentLeft, PaymentInstallmentSelection, PaymentInstallmentWrapper } from './Theme';
import { FontColors } from "theme/fontConfig";


const getInstallmentOptions = (maxValue) => {
	let installmentOptions = [];
	for (let i = 2; i <= maxValue; i++) {
		installmentOptions.push({
			value: i,
			label: `${i} monthly installments`,
		});
	}
	return installmentOptions;
};

const selectControlStyles = {
	color: FontColors.Slate3F4254,
	transition: "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
	height: "42px",
};
const colourStyles = {
	control: (styles) => ({
		...styles,
		...selectControlStyles,
	}),
	valueContainer: (styles) => ({
		...styles,
		height: "42px",
	}),
	
	menuList: (styles) => ({
		...styles,
		maxHeight: "150px",
	}),
	menu: (styles) => ({
		...styles,
		zIndex: 9999,
	}),
};

const formatOptionLabel = ({ label, _id }) => {
	return (
		<div className="dropdown-container" key={_id}>
			<div className="icon-name-container d-flex align-items-center justify-content-start">
				<div className="name-container" style={{ marginInlineStart: 10 }}>
					<div>{label}</div>
				</div>
			</div>
		</div>
	);
};

const DropdownIndicator = (props) => {
	return (
		<components.DropdownIndicator {...props}>
			<BottomArrowSvg label="Emoji" />
		</components.DropdownIndicator>
	);
};

const PaymentInstallment = ({
  onAllowInstallmentChange,
  installmentValue,
  installmentTitle = "Pay in installments",
  onSelectInstallment,
  selectedInstallment,
  installmentAmount,
	maxInstallment = 24
}) => {


  const installmentsOptions = useMemo(() => getInstallmentOptions(maxInstallment), [maxInstallment]);


  return (
    <PaymentInstallmentWrapper>
      <PaymentInstallmentLeft>
        <PaymentInstallmentCheckbox>
          <CheckBox
            onChange={onAllowInstallmentChange}
            checked={installmentValue}
            text={installmentTitle}
          />
        </PaymentInstallmentCheckbox>
        {installmentValue && (
          <PaymentInstallmentSelection>
            <Select
              classNamePrefix="react-select"
              formatOptionLabel={formatOptionLabel}
              options={installmentsOptions}
              isLoading={false}
              styles={colourStyles}
              onChange={onSelectInstallment}
              value={selectedInstallment}
              components={{ DropdownIndicator }}
            />
          </PaymentInstallmentSelection>
        )}
      </PaymentInstallmentLeft>
      <PaymentInstallmentAmount>
        {installmentAmount}
      </PaymentInstallmentAmount>
    </PaymentInstallmentWrapper>
  )
}

export default PaymentInstallment